export default __webpack_public_path__ + "static/media/eth.649bf431.webp";